import DirectInput from '../../../directInput/DirectInput';
import DropdownReg from '../../../dropdownReg/DropdownReg';
import styles from './guidQuickview.module.css';
import MultiSelect from '../../../multiselect/multiselect';
import Autocomplete from '../../../reusable-ui-components/autoCompleteSearch/Autocomplete';
import { forwardRef, useEffect, useState } from 'react';
import { fetchDropdowns } from '../../../../pages/supDropdown/dropdownFun/dropdownCRUD';
import useSectionHighlightRef from '../../../../hooks/useSectionHighlightRef';
import { fetchTypesData } from '../../../packUploadSection/quickView/fetchTypes/FetchTypes';

const GuidQuickView = forwardRef(({ guidData, setGuidData }, ref) => {
    const [dropdownData, setDropdownData] = useState([]);
    const { sectionRef, highlightField } = useSectionHighlightRef(ref);
    const diffDrop = ['Easy', 'Medium', 'Difficulty'];
    const [loading, setLoading] = useState(false);
    const [typeSel, setTypeSel] = useState('guide');
    const [typesData, setTypesData] = useState([]);
    const [languagesData, setLanguagesData] = useState([]);

    useEffect(() => {
        fetchTypesData(typeSel, 'Types', setTypesData);
    }, [typeSel]);

    useEffect(() => {
        fetchTypesData(typeSel, 'Languages', setLanguagesData);
    }, [typeSel]);

    useEffect(() => {
        setTypeSel((prev) => prev);
    }, []);

    useEffect(() => {
        fetchDropdowns(setDropdownData, setLoading, 0, 10, 'trip', 'dropdown', 'active');
    }, []);

    const baseCitiesData = dropdownData.find((item) => item.heading === 'Base Cities')?.dropdown;

    return (
        <div ref={sectionRef}>
            <h2 className={styles.orgPackUpH2}>Quick View</h2>
            <div className={styles.orgPackUpSecDiv}>
                <MultiSelect
                    label='Type / Category'
                    helperText='*Can select multiple types'
                    name='type'
                    value={guidData.quickView?.type || []}
                    data={typesData}
                    listAll={true}
                    closeListOnItemSelect={false}
                    onChange={(val) => {
                        setGuidData((prev) => ({
                            ...prev,
                            quickView: {
                                ...prev.quickView,
                                type: val
                            }
                        }));
                    }}
                    error={highlightField === 'type'}
                />
                <DropdownReg
                    label='Difficulty'
                    name={'difficulty'}
                    options={diffDrop}
                    value={guidData.quickView?.difficulty}
                    req={true}
                    setFormData={setGuidData}
                    nest='quickView'
                    error={highlightField === 'difficulty'}
                />
                {/* <DirectInput
                    label='Start Time'
                    name='startTime'
                    value={guidData.quickView?.startTime}
                    type='text'
                    placeholder='Ex - 9:00 PM'
                    setFormData={setGuidData}
                    min={6}
                    limit={9}
                    nest='quickView'
                    error={highlightField === 'startTime'}
                />
                <DirectInput
                    label='End Time'
                    name='endTime'
                    value={guidData.quickView?.endTime}
                    type='text'
                    placeholder='Ex - 9:00 PM'
                    setFormData={setGuidData}
                    min={6}
                    limit={9}
                    nest='quickView'
                    error={highlightField === 'endTime'}
                /> */}
                <DirectInput
                    label='Duration'
                    name='duration'
                    value={guidData.quickView?.duration}
                    type='text'
                    placeholder='2D/1N Or Hours'
                    setFormData={setGuidData}
                    min={2}
                    limit={9}
                    nest='quickView'
                    error={highlightField === 'duration'}
                />
                {/* <DirectInput
                    label='Where'
                    name='where'
                    value={guidData.quickView?.where}
                    type='text'
                    placeholder='Add Google location'
                    setFormData={setGuidData}
                    min={2}
                    limit={30}
                    nest='quickView'
                    error={highlightField === 'where'}
                /> */}
                <DirectInput
                    label='Trek Distance'
                    name='trekDistance'
                    value={guidData.quickView?.trekDistance}
                    type='text'
                    placeholder='Trek distance in km (Ex - 2 km), if Not a trek just enter 0 km'
                    setFormData={setGuidData}
                    min={3}
                    limit={8}
                    nest='quickView'
                    error={highlightField === 'trekDistance'}
                />
                <MultiSelect
                    label='Languages'
                    helperText='*Can select multiple languages'
                    name='languages'
                    value={guidData.quickView?.languages || []}
                    data={languagesData}
                    listAll={true}
                    closeListOnItemSelect={false}
                    onChange={(val) => {
                        setGuidData((prev) => ({
                            ...prev,
                            quickView: {
                                ...prev.quickView,
                                languages: val
                            }
                        }));
                    }}
                    error={highlightField === 'languages'}
                />
                <div style={{ display: 'flex' }}>
                    <label className={styles.guidLabel}>Base Cities</label>
                    <Autocomplete
                        dropdownData={baseCitiesData || []}
                        selectedData={guidData?.quickView?.baseCities || []}
                        onChange={(updatedArray) => {
                            setGuidData((prev) => ({
                                ...prev,
                                quickView: {
                                    ...prev.quickView,
                                    baseCities: updatedArray
                                }
                            }));
                        }}
                        multiSelect={false}
                        placeholder={'Search base cities'}
                        error={highlightField === 'baseCities'}
                    />
                </div>
                <DirectInput
                    label='Max Slots'
                    name='maxSlots'
                    value={guidData.quickView?.maxSlots}
                    type='text'
                    placeholder='Max slots availible slots(Ex - 20)'
                    setFormData={setGuidData}
                    min={1}
                    limit={3}
                    nest='quickView'
                    error={highlightField === 'maxSlots'}
                />
                <DirectInput
                    label='Area'
                    name='area'
                    value={guidData.quickView?.area}
                    type='text'
                    placeholder='Enter area (Ex - Jaynagar, Whitefield)'
                    setFormData={setGuidData}
                    min={3}
                    limit={20}
                    nest='quickView'
                    error={highlightField === 'area'}
                />
            </div>
        </div>
    );
});

export default GuidQuickView;
